export default {

    computed: {
        heights() {
            return [
                { name: '5\' 0" (152 cm)', value: '5\' 0"' },
                { name: '5\' 1" (155 cm)', value: '5\' 1"' },
                { name: '5\' 2" (157 cm)', value: '5\' 2"' },
                { name: '5\' 3" (160 cm)', value: '5\' 3"' },
                { name: '5\' 4" (163 cm)', value: '5\' 4"' },
                { name: '5\' 5" (165 cm)', value: '5\' 5"' },
                { name: '5\' 6" (168 cm)', value: '5\' 6"' },
                { name: '5\' 7" (170 cm)', value: '5\' 7"' },
                { name: '5\' 8" (173 cm)', value: '5\' 8"' },
                { name: '5\' 9" (175 cm)', value: '5\' 9"' },
                { name: '5\' 10" (178 cm)', value: '5\' 10"' },
                { name: '5\' 11" (180 cm)', value: '5\' 11"' },
                { name: '6\' 0" (183 cm)', value: '6\' 0"' },
                { name: '6\' 1" (185 cm)', value: '6\' 1"' },
                { name: '6\' 2" (188 cm)', value: '6\' 2"' },
                { name: '6\' 3" (191 cm)', value: '6\' 3"' },
                { name: '6\' 4" (193 cm)', value: '6\' 4"' },
            ]
        }
    }
}
